module.exports = __webpack_public_path__ + "static/media/ITS Banner 1160x120_0.0296076b.png";